module.exports = __webpack_public_path__ + "img/9.53de8743.jpg";